export default "__VITE_ASSET__Bghj3A2b__"